import PropertyType from '../Modifiers/PropertyType.js';

var borderValueFunc = function borderValueFunc(borderValue) {
  return "border-color: " + borderValue + ";";
};
var ThemeBlockBorderValue = new PropertyType({
  name: 'BlockBorderValue',
  propertyFromApi: 'block-border-value',
  convertValueToCssPropertiesFunction: borderValueFunc,
  selector: '.block',
  cssVariable: '--block-border-color'
}, 'theme');
var FormBlockBorderValue = new PropertyType({
  name: 'BlockBorderValue',
  propertyFromApi: 'block-border-value',
  convertValueToCssPropertiesFunction: borderValueFunc,
  selector: '.block',
  cssVariable: '--block-border-color'
}, 'form');

export { FormBlockBorderValue, ThemeBlockBorderValue };
//# sourceMappingURL=BlockBorderValue.js.map
